var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFrance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 14.9996C19.9997 15.5889 19.7655 16.1542 19.3488 16.5709C18.9321 16.9877 18.3668 17.2218 17.7775 17.2218H13.333V2.77734H17.7775C18.3668 2.77734 18.9321 3.01147 19.3488 3.42822C19.7655 3.84496 19.9997 4.4102 19.9997 4.99957V14.9996Z",
    fill: "#ED2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 2.77734C1.63285 2.77734 1.06762 3.01147 0.650874 3.42822C0.234126 3.84496 0 4.4102 0 4.99957L0 14.9996C0 15.5889 0.234126 16.1542 0.650874 16.5709C1.06762 16.9877 1.63285 17.2218 2.22222 17.2218H6.66667V2.77734H2.22222Z",
    fill: "#002495"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 2.77734H13.3337V17.2218H6.66699V2.77734Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFrance);
export default __webpack_public_path__ + "static/media/flag-france.dbba280d85b85775e1188bdec5b53a14.svg";
export { ForwardRef as ReactComponent };